import { isOptionField, } from './structure';
// Traverses a Questionnaire
// Can produce an output of the provided generic type, if no output is necessary `void` can be provided as the `Output` type.
export default class QuestionnaireVisitor {
    visitQuestionnaire(questionnaire) {
        if (questionnaire?.length > 0) {
            for (const sectionGroup of questionnaire) {
                this.visitSectionGroup(sectionGroup);
            }
        }
        // Return `questionnaire` to support mutation if needed.
        return { questionnaire };
    }
    visitSectionGroup(sectionGroup) {
        if (sectionGroup.sections?.length > 0) {
            for (const section of sectionGroup.sections) {
                this.visitSection(section);
            }
        }
    }
    visitSection(section) {
        if (section.subsections?.length > 0) {
            for (const subsection of section.subsections) {
                this.visitSubsection(subsection);
            }
        }
    }
    visitSubsection(subsection) {
        if (subsection.fieldGroups?.length > 0) {
            for (const fieldGroup of subsection.fieldGroups) {
                this.visitFieldGroup(fieldGroup);
            }
        }
    }
    visitFieldGroup(fieldGroup) {
        if (fieldGroup.fields?.length > 0) {
            for (const field of fieldGroup.fields) {
                this.visitField(field);
            }
        }
    }
    visitField(field) {
        if (isOptionField(field)) {
            if (field.options?.length > 0) {
                for (const option of field.options) {
                    this.visitOption(option);
                }
            }
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    visitOption(option) { }
}
